import { render, staticRenderFns } from "./AdminClientAccount.vue?vue&type=template&id=43753b8e"
import script from "./AdminClientAccount.vue?vue&type=script&lang=js"
export * from "./AdminClientAccount.vue?vue&type=script&lang=js"
import style0 from "./AdminClientAccount.vue?vue&type=style&index=0&id=43753b8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports